import React, { useMemo } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import {
  DURATION_DISPLAY_FORMAT_OPTIONS,
  DURATION_TOOLTIP_FORMAT_OPTIONS,
  formatDurationMinutes,
} from '../../utils/durationFormat';

export default function DurationDisplayFormatControl({
  displayFormat,
  tooltipFormat,
  onDisplayChange,
  onTooltipChange,
  previewMinutes = 107,
  size = 'small',
  showHelper = true,
}) {
  const displayPreview = useMemo(
    () => formatDurationMinutes(previewMinutes, displayFormat || 'auto'),
    [previewMinutes, displayFormat]
  );
  const tooltipPreview = useMemo(() => {
    const fmt =
      !tooltipFormat || tooltipFormat === 'same' ? displayFormat || 'auto' : tooltipFormat;
    return formatDurationMinutes(previewMinutes, fmt);
  }, [previewMinutes, displayFormat, tooltipFormat]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <FormControl fullWidth size={size}>
        <InputLabel>Formato de duración</InputLabel>
        <Select
          label="Formato de duración"
          value={displayFormat || 'auto'}
          onChange={(e) => onDisplayChange(e.target.value === 'auto' ? undefined : e.target.value)}
        >
          {DURATION_DISPLAY_FORMAT_OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth size={size}>
        <InputLabel>Formato al pasar el mouse</InputLabel>
        <Select
          label="Formato al pasar el mouse"
          value={tooltipFormat || 'verbose'}
          onChange={(e) => onTooltipChange(e.target.value === 'verbose' ? undefined : e.target.value)}
        >
          {DURATION_TOOLTIP_FORMAT_OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {showHelper && (
        <Typography variant="caption" color="text.secondary">
          Vista: <strong>{displayPreview}</strong>
          {' · '}
          Hover: <strong>{tooltipPreview}</strong>
          {' '}(ej. {previewMinutes} min)
        </Typography>
      )}
    </Box>
  );
}
